<div class="divide-y divide-gray-200 select-none overflow-hidden mt-5 bg-white shadow sm:rounded-lg">
  <div class="px-4 py-4  sm:px-6">
    <div class="text-2xl leading-6  text-gray-900">
      Umsatzaufteilung
    </div>


  </div>
  <div class="px-4  pb-1 pt-0 sm:p-6">
    <!--
      Chart.js sizing box (Bug #234). `w-full`/`h-[32rem]` are Tailwind; the old `w-100` here was BOOTSTRAP
      (`width:100%!important`, loaded before styles.scss). The height must stay definite on THIS element —
      Chart.js reads the canvas's PARENT to compute the chart size, so an auto-height wrapper collapses the
      chart to nothing.
    -->
    <div class="w-full  h-[32rem] flex justify-content-center">
      @if (revenueDistributionStore.errorCode != ErrorCodes.loading && revenueDistributionStore.errorCode != undefined) {
        <analytics-error-message
          [analysisErrorState]="revenueDistributionStore.errorCode"></analytics-error-message>
      }
      @if (revenueDistributionStore.errorCode == ErrorCodes.loading) {
        <div
          class="inline-block align-self-center h-16 w-16 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status">
        </div>
      }

      <!--
        `w-full` (Tailwind), NOT `w-100` (Bootstrap, `!important`) — Bug #234. It only paints BEFORE the first
        Chart.js render: once the chart exists, Chart.js writes an inline `style="width:…px"` derived from this
        canvas's parent, which outranks a plain utility class. The Bootstrap version outranked that inline style
        instead, so the two agreed only because the px value equals 100% of the same parent. Keeping a width
        class here is still correct — it sizes the empty canvas while the store is loading or errored.
      -->
      <canvas #pieChart [ngClass]="{ 'hidden': revenueDistributionStore.errorCode != undefined }"
              class="inline-flex sm:h-96 w-full"></canvas>

    </div>

  </div>
</div>

<div class="mt-3.5 select-none">
  <div class="sm:hidden border-2 border-gray-200 rounded-lg">
    <label class="sr-only" for="tabs">Select a tab</label>
    <select (ngModelChange)="revenueDistributionStore.changeOption($event)"
            [ngModel]="revenueDistributionStore.selectedOption"
            class="block w-full rounded-md border-gray-300 focus:border-theme-primary-900 focus:ring-theme-primary-900"
            id="tabs"
            name="tabs">
      @for (option of revenueDistributionStore.options; track option.key) {
        <option [value]="option.key">{{ option.description }}</option>
      }
    </select>
  </div>
  <div class="hidden sm:block">
    <div aria-label="Tabs" class="isolate flex divide-x divide-gray-200 rounded-lg shadow cursor-pointer">

      <a
        (click)="revenueDistributionStore.changeOption(revenueDistributionStore.options[0].key)"
        [ngClass]="{'text-gray-900!': revenueDistributionStore.selectedOption == revenueDistributionStore.options[0].key, 'text-gray-500 hover:text-gray-700': revenueDistributionStore.selectedOption != revenueDistributionStore.options[0].key}"
        class="rounded-l-lg group relative min-w-0 text-theme-primary-700 flex-1 overflow-hidden bg-white py-4 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10">
        <span>Umsatz pro Standort</span>
        <span
          [ngClass]="{'bg-theme-primary-700': revenueDistributionStore.selectedOption == revenueDistributionStore.options[0].key, 'bg-transparent': revenueDistributionStore.selectedOption != revenueDistributionStore.options[0].key}"
          aria-hidden="true"
          class="bg-transparent absolute inset-x-0 bottom-0 h-0.5"></span>
      </a>
      <a
        (click)="revenueDistributionStore.changeOption(revenueDistributionStore.options[1].key)"
        [ngClass]="{'text-gray-900!': revenueDistributionStore.selectedOption == revenueDistributionStore.options[1].key, 'text-gray-500 hover:text-gray-700': revenueDistributionStore.selectedOption != revenueDistributionStore.options[1].key}"
        class="rounded-r-lg group relative text-theme-primary-700 min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10">
        <span>Umsatz pro Kategorie</span>
        <span
          [ngClass]="{'bg-theme-primary-700': revenueDistributionStore.selectedOption == revenueDistributionStore.options[1].key, 'bg-transparent':revenueDistributionStore.selectedOption != revenueDistributionStore.options[1].key}"
          aria-hidden="true"
          class="bg-transparent absolute inset-x-0 bottom-0 h-0.5"></span>
      </a>
    </div>
  </div>
</div>

